<script>
import Feature from "./AppIconTab.vue";
export default {
  components: {
    Feature,
  },
  props: {
    content: {
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  methods: {
    showBlock(index = 0, blockLocales) { // eslint-disable-line 
      console.log(blockLocales);

      const rootLang = document.documentElement.lang;

      if (blockLocales === undefined) {
        return true
      }
      else {
        if (blockLocales.includes(rootLang)) {
          return true
        }
        else if (blockLocales[0] === 'no-show') {
          return false
        }
        else {
          return false
        }

      }
    }
  }
};
</script>
<template>
  <div class="vw-grid feature-list">
    <Feature v-for="(feature, index) in content" :key="index" :slide="feature" active="0" class="half-grid"
      v-if="showBlock(index, feature.locales)" />
  </div>
</template>

<style lang="scss" scoped>
@import "../styles/01-settings/breakpoints";
@import "../styles/01-settings/mq";

.feature-list {
  --icon-border-radius: 5px;
  padding-top: 50px;
  grid-row-gap: 50px;
}

.tab {
  margin-bottom: 0;
}

.half-grid {
  grid-column: 1/ -1;
  text-align: left;
}

@include mq($from: sm) {
  .half-grid {
    grid-column: span calc(var(--numCols) / 2);
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/FeaturesList.vue